import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "store/store";
import { Lang } from "types";

interface InitState {
  lang: Lang;
}

const initialState: InitState = {
	lang: "en",
};

export const langSlice = createSlice({
	name: "app",
	initialState,
	reducers: {
		setLang: (state, action) => {
			state.lang = action.payload;
		},
	},
});

export const { setLang } = langSlice.actions;

export const selectLang = (state: RootState) => state.lang.lang;

export default langSlice.reducer;
